/**
 * axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import { baseURL } from '@/api/url';
import store from '@/store/index.js';
import { showDialog, showToast } from 'vant';
import VueCookies from 'vue-cookies';
axios.defaults.timeout = 60000;
axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;

// 请求拦截
axios.interceptors.request.use(
  config => {
    config.headers = {
      sessionId: VueCookies.get('sessionId')
    };
    return config;
  },
  error => {
    return Promise.error(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // store.dispatch('changeStoreData', { key: 'isLoading', value: false });
    store.dispatch('changeStoreData', { key: 'isShowPage', value: true });
    if (response.status === 200) {
      response = response.data;
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    store.dispatch('changeStoreData', { key: 'isLoading', value: false });
    store.dispatch('changeStoreData', { key: 'isShowPage', value: true });
    return Promise.reject(error);
  }
);

/**
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const $post = (apiParams) => {
  let param = apiParams.data;
  let that = apiParams.that;
  const params = new URLSearchParams(); // 创建对象
  params.append('req', JSON.stringify(param)); // 封装对象
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  store.dispatch('changeStoreData', { key: 'isLoading', value: apiParams.loading });
  return new Promise((resolve, reject) => {
    axios.post(apiParams.url, params, { headers }).then(res => {
      console.log(apiParams.url + '接口入参', param);
      console.log(apiParams.url + '接口返参', res, res.code === 1);
      store.dispatch('changeStoreData', { key: 'isLoading', value: false });
      if (res.code === 0) {
        resolve(res.data);
      } else if (res.msg === '用户登录信息已失效，请重新登录') {
        console.log('1111111111');
        showDialog({
          title: '温馨提示',
          message: res.msg,
          theme: 'round-button',
          confirmButtonColor: '#3E70ED'
        }).then(() => {
          if (that.$cookies.get('sessionId')) {
            that.$store.dispatch('changeStoreData', { key: 'sessionId', value: '' });
            that.$cookies.remove('sessionId');
          }
          if (sessionStorage.getItem('getUserInfo')) {
            that.$store.dispatch('changeStoreData', { key: 'getUserInfo', value: '' });
            sessionStorage.removeItem('getUserInfo');
          }
          if (sessionStorage.getItem('memberInfo')) {
            that.$store.dispatch('changeStoreData', { key: 'memberInfo', value: '' });
            sessionStorage.removeItem('memberInfo');
          };
          that.$router.push('MineHealth');
        });
      } else {
        if (apiParams.url.includes('oss/uploadWavContent') || apiParams.url.includes('oss/uploadWechatAudioFile')) {
          console.log(res.msg);
        } else {
          showToast(res.msg);
          console.log(res.msg);
        }
      }
    }, err => {
      console.log(err);
    }).catch(err => {
      console.log(err);
    });
  });
};
/**
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const $get = (apiParams) => {
  let param = apiParams.data;
  let that = apiParams.that;
  store.dispatch('changeStoreData', { key: 'isLoading', value: apiParams.loading });
  return new Promise((resolve, reject) => {
    console.log(apiParams.url + 'get入参', param);
    console.log(apiParams.url, apiParams.url === 'chat/connect');
    let url = apiParams.url + '/' + JSON.stringify(param);
    axios.get(url).then(res => {
      console.log(apiParams.url + '接口入参', param);
      console.log(apiParams.url + '接口返参', res, res.code === 1);
      store.dispatch('changeStoreData', { key: 'isLoading', value: false });
      if (res.code === 0) {
        resolve(res.data);
      } else if (res.msg === '用户登录信息已失效，请重新登录') {
        showDialog({
          title: '温馨提示',
          message: res.msg,
          theme: 'round-button',
          confirmButtonColor: '#3E70ED'
        }).then(() => {
          if (that.$cookies.get('sessionId')) {
            that.$store.dispatch('changeStoreData', { key: 'sessionId', value: '' });
            that.$cookies.remove('sessionId');
          }
          if (sessionStorage.getItem('getUserInfo')) {
            that.$store.dispatch('changeStoreData', { key: 'getUserInfo', value: '' });
            sessionStorage.removeItem('getUserInfo');
          }
          if (sessionStorage.getItem('memberInfo')) {
            that.$store.dispatch('changeStoreData', { key: 'memberInfo', value: '' });
            sessionStorage.removeItem('memberInfo');
          }
          that.$router.push('MineHealth');
        });
      } else {
        showToast(res.msg);
        console.log(res.msg);
      }
    }, err => {
      console.log(err);
    }).catch(err => {
      console.log(err);
    });
  });
};
export {
  $get, $post
};
